import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type {
    ApiStockActInvContentData,
    ApiStockActInvContentUpdateFactQtyData,
    ApiStockActInvData,
    StockActInvContentFilter,
    StockActInvFilter,
} from "./types";

interface StockActInvsResponse {
    outData: ApiStockActInvData[];
}

interface StockActInvContentsResponse {
    stockActInvContents: ApiStockActInvContentData[];
}

/** Транспортный слой OMP — АИ СУ и состав АИ для полной инвентаризации склада. */
export const stockActInvsApi = {
    /**
     * Загружает АИ СУ по фильтру.
     * @param params фильтр АИ
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: StockActInvFilter;
        },
        config?: RequestConfig,
    ): Promise<ApiStockActInvData[]> => {
        const data = await ompApiClient.postOmega<StockActInvsResponse>(
            "stock/stockActInv.loadByFilter",
            { flt: params.flt },
            config,
        );

        return data.outData;
    },

    /** Состав АИ СУ. */
    content: {
        /**
         * Загружает строки состава АИ.
         * @param params фильтр состава АИ
         * @param config опции HTTP-запроса
         */
        load: async (
            params: {
                flt?: StockActInvContentFilter;
            },
            config?: RequestConfig,
        ): Promise<ApiStockActInvContentData[]> => {
            const data = await ompApiClient.postOmega<StockActInvContentsResponse>(
                "stock/stockActInv/contents.loadByFilter",
                { flt: params.flt },
                config,
            );

            return data.stockActInvContents;
        },

        /**
         * Обновляет фактические количества по строкам состава АИ.
         * @param params данные фактических количеств
         * @param config опции HTTP-запроса
         */
        updateFactQties: async (
            params: {
                qties: ApiStockActInvContentUpdateFactQtyData[];
            },
            config?: RequestConfig,
        ): Promise<void> => {
            await ompApiClient.postOmega("stock/stockActInv/contents.updateFactQties", { qties: params.qties }, config);
        },
    },
};
